import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { X } from "lucide-react";
import "../styles/loginModal.css";

const LoginModal = ({
    isOpen,
    onClose,
    onGoogleLogin,
    onSendOtp,
    onVerifyOtp,
    mobileNumber,
    setMobileNumber,
    otp,
    setOtp,
    otpSent,
    isLoginLoading,
    isUserClickSignIn
}) => {
    if (!isOpen) return null;

    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <button
                    className="modal-close-btn"
                    aria-label="Close modal"
                    style={{
                        position: "absolute",
                        top: "16px",
                        right: "16px",
                        background: "transparent",
                        border: "none",
                        color: "#666",
                        cursor: "pointer",
                        zIndex: 10,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "4px",
                        borderRadius: "50%",
                        transition: "background-color 0.2s"
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.05)"}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                    onClick={onClose}
                >
                    <X size={20} strokeWidth={2.5} />
                </button>

                <div className="login-logo">
                    <img src="/logo_new.svg" alt="Routechef Logo" />
                    <span>
                        <span style={{ color: "#FF5B15", fontWeight: "600" }}>
                            Route
                        </span>
                        <span style={{ color: "#0A0A0A", fontWeight: "400" }}>
                            chef
                        </span>
                    </span>
                </div>
                <h2 className="welcome-back">Welcome back</h2>

                <button
                    className="modal-oauth-btn google-btn"
                    onClick={onGoogleLogin}
                    disabled={isLoginLoading}
                    style={{
                        opacity: isLoginLoading ? 0.7 : 1,
                        cursor: isLoginLoading ? "not-allowed" : "pointer",
                    }}
                >
                    {isLoginLoading ? (
                        <div
                            className="button-loader"
                            style={{ marginRight: "8px" }}
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    ) : (
                        <img
                            src="/googleIcon.svg"
                            alt="Google Icon"
                            className="google-icon"
                        />
                    )}
                    <span>
                        {isLoginLoading ? "Signing in..." : "Sign in with Google"}
                    </span>
                </button>

                <div className="modal-divider-new">
                    <span>OR</span>
                </div>

                {!otpSent ? (
                    <form className="modal-login-form" onSubmit={onSendOtp}>
                        <label htmlFor="mobile-input">Mobile Number</label>
                        <PhoneInput
                            country={"in"}
                            value={mobileNumber}
                            onChange={setMobileNumber}
                            disableFormatting={true}
                            inputProps={{
                                id: "mobile-input",
                                required: true,
                                name: "mobile",
                                autoFocus: true,
                                "aria-label": "Mobile number input",
                                disabled: isLoginLoading,
                            }}
                            enableSearch={true}
                            containerClass="phone-input-container"
                            inputClass="phone-input-field"
                            buttonClass="phone-input-dropdown"
                            dropdownClass="phone-input-country-dropdown"
                        />
                        <button
                            type="submit"
                            className="modal-login-btn sign-in-btn"
                            disabled={isLoginLoading}
                            style={{
                                opacity: isLoginLoading ? 0.7 : 1,
                                cursor: isLoginLoading ? "not-allowed" : "pointer",
                            }}
                        >
                            {isLoginLoading ? (
                                <div className="button-loader">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            ) : (
                                "Send OTP"
                            )}
                        </button>
                    </form>
                ) : (
                    <form
                        className="modal-login-form"
                        onSubmit={onVerifyOtp}
                    >
                        <label htmlFor="otp-input">Enter OTP</label>
                        <input
                            id="otp-input"
                            type="text"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            placeholder="Enter the 6-digit OTP"
                            aria-label="OTP input"
                            className="login-input"
                            disabled={isLoginLoading}
                        />
                        <button
                            type="submit"
                            className="modal-login-btn sign-in-btn"
                            disabled={isLoginLoading}
                            style={{
                                opacity: isLoginLoading ? 0.7 : 1,
                                cursor: isLoginLoading ? "not-allowed" : "pointer",
                            }}
                        >
                            {isLoginLoading ? (
                                <div className="button-loader">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            ) : (
                                "Verify OTP"
                            )}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default LoginModal;
